import { createAnalyticsEvent } from 'analytics/create-analytics-event';
import { GAEventName } from 'analytics/ga-event-name.enum';
import { LocaleEnum, LocaleStore } from 'schema/locale';

type DynamicLanderViewEventPayload = {
  locale: LocaleEnum;
  path: string;
};

export const dynamicLanderViewEvent = createAnalyticsEvent(
  ({ locale, path }: DynamicLanderViewEventPayload) => ({
    event: GAEventName.DYNAMIC_LANDERS_VIEW,
    locale,
    store: LocaleStore[locale],
    path: path.replace('/landers', '')
  })
);
